const focusAreas = [
  [
    { label: 'Prescription Management', href: '/pharmacy-services' },
    { label: 'Medication Reviews', href: '/pharmacy-services' },
    { label: 'Chronic Disease Support', href: '/pharmacy-services' },
    { label: 'Compounding Services', href: '/pharmacy-services' },
  ],
  [
    { label: 'Methadone Treatment', href: '/methadone-treatment' },
    { label: 'Suboxone Programs', href: '/suboxone-treatment' },
    { label: 'Smoking Cessation', href: '/pharmacy-services' },
    { label: 'Overdose Prevention', href: '/naloxone-kits' },
  ],
  [
    { label: 'Travel Health Consults', href: '/pharmacy-services' },
    { label: 'Vaccination Services', href: '/pharmacy-services' },
    { label: "Women's Health", href: '/pharmacy-services' },
    { label: 'Senior Care Programs', href: '/pharmacy-services' },
  ],
];

export default function AreasOfFocus() {
  return (
    <section className="py-16 sm:py-24 bg-[#FAFAF7]">
      <div className="max-w-4xl mx-auto px-4 sm:px-6">
        {/* Header */}
        <header className="text-center mb-12 sm:mb-16">
          <h2
            className="text-3xl sm:text-4xl md:text-[44px] text-[#2D2D2D] mb-4"
            style={{ fontFamily: "'Playfair Display', serif", fontWeight: 400 }}
          >
            Areas of <em className="not-italic" style={{ fontStyle: 'italic' }}>focus</em>
          </h2>
          <p
            className="text-[10px] sm:text-[11px] uppercase tracking-[0.3em] text-gray-500 max-w-2xl mx-auto leading-relaxed"
            style={{ fontFamily: "'Roboto Condensed', sans-serif", fontWeight: 400 }}
          >
            Specialized support for specific challenges
          </p>
        </header>

        {/* Three-column bullet list */}
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-x-8 gap-y-3 sm:gap-y-2 mb-16 sm:mb-24">
          {focusAreas.map((column, colIdx) => (
            <ul key={colIdx} className="space-y-2 sm:space-y-3">
              {column.map((item, itemIdx) => (
                <li
                  key={itemIdx}
                  className="flex items-start text-[12px] sm:text-[13px] text-[#2D2D2D] leading-relaxed"
                  style={{ fontFamily: "'Roboto Condensed', sans-serif", fontWeight: 400 }}
                >
                  <span className="mr-2 mt-[2px]">&bull;</span>
                  <a
                    href={item.href}
                    className="cursor-pointer hover:underline underline-offset-2 decoration-gray-400 transition-colors"
                  >
                    {item.label}
                  </a>
                </li>
              ))}
            </ul>
          ))}
        </div>

        {/* Quote */}
        <div className="text-center">
          <p
            className="text-2xl sm:text-3xl md:text-[40px] text-[#2D2D2D] leading-tight max-w-3xl mx-auto"
            style={{ fontFamily: "'Playfair Display', serif", fontWeight: 400 }}
          >
            At Thornhill Drug-Mart,
            <br />
            care <em className="not-italic" style={{ fontStyle: 'italic' }}>isn't</em> just about medication,
            <br />
            <em className="not-italic" style={{ fontStyle: 'italic' }}>it's</em> about compassion.
          </p>
        </div>
      </div>
    </section>
  );
}
